import { Model, Store } from 'store/Base';
import { observable } from 'mobx';


export class Entity extends Model {
    static backendResourceName = 'entity';
    static omitFields = []

    @observable id = null;
    @observable name = '';


}

export class EntityStore extends Store {
    Model = Entity;
    static backendResourceName = 'entity';
}
